import * as React from 'react'; // https://github.com/parcel-bundler/parcel/issues/1199

interface OptInInputProps {
    isErrored: boolean;
    onChange: Function;
    value: boolean;
}

const OptInInput = ({
    isErrored,
    onChange,
    value,
}: OptInInputProps) => {

    return (
        <div className="sid-checkbox">
            <input
                className="sid-checkbox__input"
                id="sid-opt-in"
                name="sid-opt-in"
                type="checkbox"
                checked={value}
                onChange={e => onChange(e.target.checked)}
            />
            <span className={`sid-checkbox__input-like ${isErrored ? 'sid-checkbox__input-like--error' : ''}`}></span>
        </div>
    );
};

export const OptInInputComponent = OptInInput;
